// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_math from "../../../../node_modules/rescript/lib/es6/js_math.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Video$Showside from "../utils/Video.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as Debugger$Showside from "../utils/Debugger.bs.js";
import * as IconPlay$Showside from "../icons/IconPlay.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as IconButton$Showside from "./IconButton.bs.js";
import * as WebapiVideo$Showside from "../utils/WebapiVideo.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as ResizeObserver$Showside from "../utils/ResizeObserver.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import ReactVisibilitySensor from "react-visibility-sensor";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
var transparent1x1Gif = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
var queueRef = {
  contents: []
};
var callbacksRef = {
  contents: []
};
var videoElDictRef = {
  contents: {}
};
var currentPlaybackIdRef = {
  contents: undefined
};
var initialPlaybackIdRef = {
  contents: undefined
};
function getVideoElById(id) {
  return Js_dict.get(videoElDictRef.contents, id);
}
function getNextId(id) {
  var currentIdx = Belt_Option.getWithDefault(Belt_Array.getIndexBy(queueRef.contents, function (id0) {
    return id0 === id;
  }), 0);
  var nextIdx = currentIdx >= (queueRef.contents.length - 1 | 0) || currentIdx < 0 ? 0 : currentIdx + 1 | 0;
  return Belt_Array.get(queueRef.contents, nextIdx);
}
function updatePreloadAttribute(id) {
  var el = Js_dict.get(videoElDictRef.contents, id);
  var indexInQueue = Belt_Option.getWithDefault(Belt_Array.getIndexBy(queueRef.contents, function (id0) {
    return id0 === id;
  }), -1);
  var currentPreloadValue;
  if (el !== undefined) {
    var match = Caml_option.valFromOption(el).preload;
    switch (match) {
      case "auto":
        currentPreloadValue = "auto";
        break;
      case "metadata":
        currentPreloadValue = "metadata";
        break;
      default:
        currentPreloadValue = "none";
    }
  } else {
    currentPreloadValue = "none";
  }
  var nextPreloadValue = indexInQueue === 0 || indexInQueue === 1 ? "auto" : indexInQueue > 1 && currentPreloadValue === "none" ? "metadata" : currentPreloadValue;
  if (el !== undefined) {
    Caml_option.valFromOption(el).preload = nextPreloadValue;
    return;
  }
}
function setQueue(queue) {
  queueRef.contents = queue;
  Belt_Array.forEach(queue, updatePreloadAttribute);
  Belt_Array.forEach(callbacksRef.contents, function (fn) {
    Curry._1(fn, queue);
  });
}
function addCallback(fn) {
  callbacksRef.contents = Belt_Array.concat(callbacksRef.contents, [fn]);
}
function removeCallback(fn) {
  callbacksRef.contents = Belt_Array.keep(callbacksRef.contents, function (fnGot) {
    return fnGot !== fn;
  });
}
function cycleQueue(id) {
  var requiredSteps = id !== undefined ? Belt_Array.getIndexBy(queueRef.contents, function (id$1) {
    return id$1 === id;
  }) : undefined;
  var cycle = function (param) {
    var first = Belt_Array.get(queueRef.contents, 0);
    if (first !== undefined) {
      return setQueue(Belt_Array.concat(Belt_Array.keep(queueRef.contents, function (v) {
        return v !== first;
      }), [first]));
    }
  };
  if (requiredSteps === undefined) {
    return;
  }
  for (var i = 0; i < requiredSteps; ++i) {
    cycle(i);
  }
}
function pauseAll(param) {
  currentPlaybackIdRef.contents = undefined;
  Belt_Array.forEach(Js_dict.values(videoElDictRef.contents), function (el) {
    el.pause();
  });
}
function resetTime(el) {
  el.currentTime = 0.0;
}
function setInitialPlaybackId(id) {
  var match = initialPlaybackIdRef.contents;
  if (match !== undefined) {
    return;
  } else {
    initialPlaybackIdRef.contents = id;
    return;
  }
}
function playById(id) {
  pauseAll(undefined);
  var videoEl = Js_dict.get(videoElDictRef.contents, id);
  if (videoEl === undefined) {
    return;
  }
  var el = Caml_option.valFromOption(videoEl);
  el.currentTime = 0.0;
  setInitialPlaybackId(id);
  WebapiVideo$Showside.playWithRetries(undefined, el).then(function (param) {
    currentPlaybackIdRef.contents = id;
  });
}
function pauseById(id) {
  Belt_Option.forEach(Js_dict.get(videoElDictRef.contents, id), function (video) {
    video.pause();
  });
}
function removeFromCurrent(id) {
  if (Caml_obj.equal(currentPlaybackIdRef.contents, id)) {
    currentPlaybackIdRef.contents = undefined;
    return;
  }
}
function removeFromInitial(id) {
  if (Caml_obj.equal(initialPlaybackIdRef.contents, id)) {
    initialPlaybackIdRef.contents = undefined;
    return;
  }
}
function removeVideoElementFromDictById(id) {
  videoElDictRef.contents = Js_dict.fromArray(Belt_Array.keep(Js_dict.entries(videoElDictRef.contents), function (param) {
    return param[0] !== id;
  }));
}
function onVideoEnds(e) {
  var element = e.target;
  var id = element.getAttribute("data-id");
  var id$1 = id == null ? undefined : Caml_option.some(id);
  var nextId = Belt_Option.flatMap(id$1, getNextId);
  removeFromCurrent(id$1);
  cycleQueue(nextId);
}
function onTimeUpdate(e) {
  var element = e.target;
  var currentTime = element.currentTime;
  var duration = element.duration;
  if (currentTime >= duration) {
    return onVideoEnds(e);
  }
}
function enqueue(prioritizeOpt, id, el, src) {
  var prioritize = prioritizeOpt !== undefined ? prioritizeOpt : false;
  var queueWithoutSelf = Belt_Array.keep(queueRef.contents, function (id0) {
    return id0 !== id;
  });
  if (prioritize) {
    setQueue(Belt_Array.concat([id], queueWithoutSelf));
  } else {
    setQueue(Belt_Array.concat(queueWithoutSelf, [id]));
  }
  el.setAttribute("data-id", id);
  el.removeEventListener("ended", onVideoEnds);
  el.addEventListener("ended", onVideoEnds);
  el.removeEventListener("timeupdate", onTimeUpdate);
  el.addEventListener("timeupdate", onTimeUpdate);
  videoElDictRef.contents[id] = el;
}
function dequeue(id) {
  Belt_Option.forEach(Js_dict.get(videoElDictRef.contents, id), function (el) {
    el.removeEventListener("ended", onVideoEnds);
    el.removeEventListener("timeupdate", onTimeUpdate);
  });
  setQueue(Belt_Array.keep(queueRef.contents, function (id0) {
    return id0 !== id;
  }));
  pauseById(id);
  removeFromCurrent(id);
  removeFromInitial(id);
}
var userConfigRef = {
  contents: {
    paused: false,
    loop: false,
    autoPlay: true
  }
};
function playCurrent(param) {
  var isCurrentlyPlaying = function (id) {
    return Caml_obj.equal(id, currentPlaybackIdRef.contents);
  };
  var canLoop = function (id) {
    if (userConfigRef.contents.loop) {
      return true;
    } else {
      return Caml_obj.notequal(id, initialPlaybackIdRef.contents);
    }
  };
  var firstInQueue = Belt_Array.get(queueRef.contents, 0);
  if (firstInQueue !== undefined && !isCurrentlyPlaying(firstInQueue) && canLoop(firstInQueue)) {
    return playById(firstInQueue);
  }
}
function userPaused(param) {
  var init = userConfigRef.contents;
  userConfigRef.contents = {
    paused: true,
    loop: init.loop,
    autoPlay: init.autoPlay
  };
  pauseAll(undefined);
}
function userPlayed(id) {
  var init = userConfigRef.contents;
  userConfigRef.contents = {
    paused: false,
    loop: init.loop,
    autoPlay: init.autoPlay
  };
  cycleQueue(id);
  playCurrent(undefined);
}
function userLooping(value) {
  var init = userConfigRef.contents;
  userConfigRef.contents = {
    paused: init.paused,
    loop: value,
    autoPlay: init.autoPlay
  };
}
function userAutoPlaying(value) {
  var init = userConfigRef.contents;
  userConfigRef.contents = {
    paused: init.paused,
    loop: init.loop,
    autoPlay: value
  };
}
var eventLoopTimeoutRef = {
  contents: undefined
};
function clearEventLoop(param) {
  var id = eventLoopTimeoutRef.contents;
  if (id !== undefined) {
    clearTimeout(Caml_option.valFromOption(id));
    return;
  }
}
function eventLoop(param) {
  clearEventLoop(undefined);
  eventLoopTimeoutRef.contents = Caml_option.some(setTimeout(function (param) {
    if (userConfigRef.contents.paused || !userConfigRef.contents.autoPlay) {} else {
      playCurrent(undefined);
    }
    eventLoop(undefined);
  }, 500));
}
eventLoop(undefined);
function useQueueObserver(param) {
  var match = React.useState(function () {
    return queueRef.contents;
  });
  var setQueue = match[1];
  var match$1 = React.useState(function () {
    return currentPlaybackIdRef.contents;
  });
  var setCurrentPlaybackId = match$1[1];
  React.useEffect(function () {
    var callback = function (updatedQueue) {
      Curry._1(setQueue, function (param) {
        return updatedQueue;
      });
      Curry._1(setCurrentPlaybackId, function (param) {
        return currentPlaybackIdRef.contents;
      });
    };
    addCallback(callback);
    return function (param) {
      removeCallback(callback);
    };
  }, []);
  return [match[0], match$1[0]];
}
function SmartNavVideo$InternalDebugger(Props) {
  var id = Props.id;
  var extraLogsOpt = Props.extraLogs;
  var children = Props.children;
  var extraLogs = extraLogsOpt !== undefined ? extraLogsOpt : [];
  var el = Js_dict.get(videoElDictRef.contents, id);
  var preload = el !== undefined ? Caml_option.valFromOption(el).preload : undefined;
  var match = useQueueObserver(undefined);
  var currentPlaybackId = match[1];
  return React.createElement(Debugger$Showside.make, {
    anchor: "right",
    logs: Belt_Array.concat(Belt_Array.concat(extraLogs, [Belt_Option.mapWithDefault(preload, {
      TAG: /* Log */0,
      _0: ""
    }, function (v) {
      return {
        TAG: /* Log */0,
        _0: "[preload=" + v + "]"
      };
    })]), Belt_Array.map(match[0], function (queue) {
      if (Caml_obj.equal(queue, currentPlaybackId) && queue === id) {
        return {
          TAG: /* Error */1,
          _0: queue
        };
      } else if (Caml_obj.equal(queue, currentPlaybackId)) {
        return {
          TAG: /* Warn */3,
          _0: queue
        };
      } else if (queue === id) {
        return {
          TAG: /* Info */2,
          _0: queue
        };
      } else {
        return {
          TAG: /* Log */0,
          _0: queue
        };
      }
    })),
    enabled: false,
    children: children
  });
}
SmartNavVideo$InternalDebugger.displayName = "SmartNavVideo.InternalDebugger";
var InternalDebugger = {
  make: SmartNavVideo$InternalDebugger
};
function SmartNavVideo(Props) {
  var src = Props.src;
  var poster = Props.poster;
  var viewport = Props.viewport;
  var parentRef = Props.parentRef;
  var objectFitOpt = Props.objectFit;
  var controlsClassNameOpt = Props.controlsClassName;
  var altOpt = Props.alt;
  var disabledOpt = Props.disabled;
  var showIndicatorOpt = Props.showIndicator;
  var prioritizeOpt = Props.prioritize;
  var dataTestId = Props.dataTestId;
  var dataId = Props.dataId;
  var onTimeChange = Props.onTimeChange;
  var autoplay = Props.autoplay;
  var loop = Props.loop;
  var muted = Props.muted;
  var controls = Props.controls;
  var objectFit = objectFitOpt !== undefined ? objectFitOpt : "cover";
  var controlsClassName = controlsClassNameOpt !== undefined ? controlsClassNameOpt : "";
  var alt = altOpt !== undefined ? altOpt : "";
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var showIndicator = showIndicatorOpt !== undefined ? showIndicatorOpt : false;
  var prioritize = prioritizeOpt !== undefined ? prioritizeOpt : false;
  var match = React.useState(function () {
    return String(Js_math.random_int(100000, 999999));
  });
  var id = match[0];
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var disabled$1 = disabled || match$1.isQuickView;
  var match$2 = React.useState(function () {
    return false;
  });
  var setIsOnScreen = match$2[1];
  var disabled$2 = disabled$1 || !match$2[0];
  var match$3 = React.useState(function () {
    return false;
  });
  var setVisible = match$3[1];
  var visible = match$3[0];
  var match$4 = ViewportContext$Showside.use(undefined);
  var match$5 = match$4.windowSize;
  var windowHeight = match$5.height;
  var windowWidth = match$5.width;
  var isMobile = match$4.isMobile;
  var match$6 = React.useState(function () {
    return false;
  });
  var setPlaying = match$6[1];
  var playing = match$6[0];
  var match$7 = React.useState(function () {
    return muted;
  });
  var setMuted = match$7[1];
  var muted$1 = match$7[0];
  var match$8 = React.useState(function () {
    return false;
  });
  var setHideControls = match$8[1];
  React.useEffect(function () {
    Curry._1(setMuted, function (param) {
      return muted$1;
    });
  }, [muted$1]);
  var videoRef = React.useRef(null);
  var videoEl = videoRef.current;
  var sizerRef = React.useRef(null);
  var size = Belt_Option.getWithDefault(ResizeObserver$Showside.useResizeObserver(undefined, sizerRef), {
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  var loop$1 = loop && !autoplay;
  var offsetMultiplier = size.height >= windowHeight ? 1.2 : 3.0;
  var offsetY = -(size.height / offsetMultiplier) | 0;
  var offsetX = -(size.width / offsetMultiplier) | 0;
  React.useEffect(function () {
    var timeout0 = !autoplay ? Caml_option.some(setTimeout(function (param) {
      userPaused(undefined);
      userAutoPlaying(false);
    }, 0)) : undefined;
    var timeout1 = setTimeout(function (param) {
      userLooping(loop$1);
    }, 0);
    return function (param) {
      dequeue(id);
      removeVideoElementFromDictById(id);
      Belt_Option.forEach(timeout0, function (prim) {
        clearTimeout(prim);
      });
      clearTimeout(timeout1);
    };
  }, []);
  var onPlay = React.useCallback(function (param) {
    Curry._1(setPlaying, function (param) {
      return true;
    });
    Curry._1(setHideControls, function (param) {
      return true;
    });
  }, [setPlaying, setHideControls]);
  var onPause = React.useCallback(function (param) {
    Curry._1(setPlaying, function (param) {
      return false;
    });
    Curry._1(setHideControls, function (param) {
      return false;
    });
  }, [setPlaying, setHideControls]);
  React.useEffect(function () {
    if (visible) {
      if (!disabled$2 && !(videoEl == null)) {
        enqueue(prioritize, id, videoEl, src);
      }
    } else {
      dequeue(id);
    }
  }, [visible]);
  var onVisible = function (param) {
    Curry._1(setVisible, function (param) {
      return true;
    });
  };
  var onInvisible = function (param) {
    Curry._1(setPlaying, function (param) {
      return false;
    });
    Curry._1(setVisible, function (param) {
      return false;
    });
  };
  React.useEffect(function () {
    if (disabled$2) {
      dequeue(id);
      Curry._1(setPlaying, function (param) {
        return false;
      });
    } else if (visible) {
      Curry._1(setVisible, function (param) {
        return true;
      });
    }
  }, [disabled$2]);
  var buttonSize = isMobile ? /* Small */3 : undefined;
  var renderPlayButton = function (param) {
    var onClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      Curry._1(setPlaying, function (playing) {
        return !playing;
      });
      if (playing) {
        return userPaused(undefined);
      } else {
        return userPlayed(id);
      }
    };
    if (autoplay) {
      return null;
    }
    var tmp = {
      onClick: onClick,
      dark: true,
      clear: true,
      icon: playing ? React.createElement(Unicons$Showside.UilPause.make, {}) : React.createElement(Unicons$Showside.UilPlay.make, {}),
      title: playing ? "Pause" : "Play",
      dataTestId: "video-control-play",
      dataActive: playing
    };
    if (buttonSize !== undefined) {
      tmp.size = Caml_option.valFromOption(buttonSize);
    }
    return React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["absolute bottom-0 left-0", isMobile ? "pr-3 pb-3" : "pr-4 pb-4"]))
    }, React.createElement(IconButton$Showside.make, tmp));
  };
  var renderVolumeButton = function (param) {
    var onClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      Curry._1(setMuted, function (param) {
        return !muted$1;
      });
    };
    var tmp = {
      onClick: onClick,
      dark: true,
      clear: true,
      icon: muted$1 ? React.createElement(Unicons$Showside.UilVolumeMute.make, {}) : React.createElement(Unicons$Showside.UilVolume.make, {}),
      title: muted$1 ? "Unmute" : "Mute",
      dataTestId: "video-control-mute",
      dataActive: muted$1
    };
    if (buttonSize !== undefined) {
      tmp.size = Caml_option.valFromOption(buttonSize);
    }
    return React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["absolute bottom-0 right-0", isMobile ? "pr-3 pb-3" : "pr-4 pb-4"]))
    }, React.createElement(IconButton$Showside.make, tmp));
  };
  var onMouseMove = function (e) {
    Curry._1(setHideControls, function (param) {
      return false;
    });
  };
  var onMouseEnter = function (e) {
    if (!controls || autoplay) {
      return userPlayed(id);
    }
  };
  var onMouseLeave = function (e) {
    Curry._1(setHideControls, function (param) {
      return playing;
    });
  };
  React.useEffect(function () {
    var play = function (param) {
      userPlayed(id);
    };
    var el = Belt_Option.flatMap(parentRef, function (ref) {
      return Caml_option.nullable_to_opt(ref.current);
    });
    if (el === undefined) {
      return;
    }
    if (!autoplay) {
      return;
    }
    var el$1 = Caml_option.valFromOption(el);
    el$1.removeEventListener("mouseenter", play);
    el$1.addEventListener("mouseenter", play);
    return function (param) {
      el$1.removeEventListener("mouseenter", play);
    };
  }, [parentRef]);
  var videoVisibility = playing ? "opacity-100" : "opacity-0";
  var onChangeTimeout = React.useRef(undefined);
  React.useEffect(function () {
    return function (param) {
      Belt_Option.forEach(onChangeTimeout.current, function (prim) {
        clearTimeout(prim);
      });
    };
  }, []);
  var onChange = React.useCallback(function (visible) {
    var timeout = onChangeTimeout.current;
    if (timeout !== undefined) {
      clearTimeout(Caml_option.valFromOption(timeout));
    }
    onChangeTimeout.current = Caml_option.some(setTimeout(function (param) {
      if (visible) {
        return Curry._1(setVisible, function (param) {
          return true;
        });
      } else {
        Curry._1(setPlaying, function (param) {
          return false;
        });
        return Curry._1(setVisible, function (param) {
          return false;
        });
      }
    }, 0));
  }, [onVisible, onInvisible]);
  var onChangeOuter = React.useCallback(function (visible) {
    if (visible) {
      return Curry._1(setIsOnScreen, function (param) {
        return true;
      });
    } else {
      return Curry._1(setIsOnScreen, function (param) {
        return false;
      });
    }
  }, [setIsOnScreen]);
  var render = function (containment, param) {
    var tmp = {
      partialVisibility: false,
      onChange: onChange,
      children: React.createElement("div", {
        ref: ReactDOMUtils$Showside.Ref.domRef(sizerRef),
        className: CSS$Showside.prefix("absolute top-0 left-0 w-full h-full")
      }),
      offset: {
        top: offsetY,
        left: offsetX,
        right: offsetX,
        bottom: offsetY
      },
      intervalCheck: true
    };
    if (containment !== undefined) {
      tmp.containment = Caml_option.valFromOption(containment);
    }
    var tmp$1 = {
      partialVisibility: false,
      onChange: onChangeOuter,
      children: React.createElement(ReactVisibilitySensor, tmp),
      offset: {
        top: (-windowHeight | 0) << 1,
        left: (-windowWidth | 0) << 1,
        right: (-windowWidth | 0) << 1,
        bottom: (-windowHeight | 0) << 1
      }
    };
    if (containment !== undefined) {
      tmp$1.containment = Caml_option.valFromOption(containment);
    }
    return React.createElement(ReactVisibilitySensor, tmp$1);
  };
  var containment = Belt_Option.flatMap(viewport, function (v) {
    return Caml_option.nullable_to_opt(v.current);
  });
  var visibilitySensor = containment !== undefined ? render(Caml_option.some(Caml_option.valFromOption(containment)), undefined) : render(undefined, undefined);
  var indicator = showIndicator ? React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute top-0 right-0 pointer-events-none transition duration-300 text-white drop-shadow filter", playing ? "opacity-0" : "opacity-100", isMobile ? "m-3 mr-2" : "m-4 mr-3"]))
  }, React.createElement(IconPlay$Showside.make, {
    className: isMobile ? CSS$Showside.prefix("w-5.5 h-5.5") : CSS$Showside.prefix("w-7 h-7")
  })) : null;
  var controls$1 = controls ? React.createElement(DataAttribute$Showside.make, {
    dataTestId: "video-controls",
    children: React.createElement("div", {
      className: Cn.make([CSS$Showside.prefix("absolute inset-0"), controlsClassName])
    }, React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["absolute inset-0 flex gap-2 items-center justify-center transition-opacity", !match$8[0] || isMobile ? "opacity-100 duration-150" : "opacity-0 delay-2500 duration-500"]))
    }, renderPlayButton(undefined), renderVolumeButton(undefined)))
  }) : null;
  var match$9 = useQueueObserver(undefined);
  var indexInQueue = Belt_Option.getWithDefault(Belt_Array.getIndexBy(match$9[0], function (item) {
    return item === id;
  }), -1);
  var isFarInQueue = indexInQueue > 1 || indexInQueue < 0;
  var tmp = {
    fit: objectFit === "contain" ? /* Contain */2 : objectFit === "scale-down" ? /* ScaleDown */0 : /* Cover */1,
    alt: alt,
    priority: 1
  };
  if (poster !== undefined) {
    tmp.src = poster;
  }
  var tmp$1;
  if (disabled$2) {
    tmp$1 = null;
  } else {
    var tmp$2 = {
      src: src,
      controls: false,
      loop: loop$1,
      muted: muted$1,
      poster: transparent1x1Gif,
      width: "100%",
      height: "100%",
      preload: "none",
      videoRef: videoRef,
      onPlay: onPlay,
      onPause: onPause,
      objectFit: objectFit,
      cssPrefix: CSS$Showside.prefix,
      disabled: isFarInQueue
    };
    if (onTimeChange !== undefined) {
      tmp$2.onTimeChange = Caml_option.valFromOption(onTimeChange);
    }
    if (dataTestId !== undefined) {
      tmp$2.dataTestId = Caml_option.valFromOption(dataTestId);
    }
    if (dataId !== undefined) {
      tmp$2.dataId = dataId;
    }
    tmp$1 = React.createElement(Video$Showside.make, tmp$2);
  }
  return React.createElement("div", {
    className: CSS$Showside.prefix("absolute inset-0 flex items-center justify-center"),
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onMouseMove: onMouseMove
  }, visibilitySensor, React.createElement("div", {
    className: CSS$Showside.prefix("absolute inset-0")
  }, React.createElement(SmartImg$Showside.make, tmp)), React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make([videoVisibility, "transition-opacity duration-300", "absolute inset-0"]))
  }, tmp$1), indicator, controls$1);
}
SmartNavVideo.displayName = "SmartNavVideo";
var make = React.memo(SmartNavVideo);
var enableDebugger = false;
export { enableDebugger, transparent1x1Gif, queueRef, callbacksRef, videoElDictRef, currentPlaybackIdRef, initialPlaybackIdRef, getVideoElById, getNextId, updatePreloadAttribute, setQueue, addCallback, removeCallback, cycleQueue, pauseAll, resetTime, setInitialPlaybackId, playById, pauseById, removeFromCurrent, removeFromInitial, removeVideoElementFromDictById, onVideoEnds, onTimeUpdate, enqueue, dequeue, userConfigRef, playCurrent, userPaused, userPlayed, userLooping, userAutoPlaying, eventLoopTimeoutRef, clearEventLoop, eventLoop, useQueueObserver, InternalDebugger, make };
/*  Not a pure module */